var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-slider__content" }, [
    _c(
      "div",
      { ref: "sliderContainer", staticClass: "product-slider__container" },
      [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.productsList, function (item, index) {
            return _c(
              "div",
              {
                key: "product-slide-" + index,
                staticClass: "product-slide",
                attrs: { "data-entity": "items-row" },
              },
              [
                _c("productItem", {
                  attrs: {
                    "product-id": item.id,
                    "product-name": item.name,
                    "product-node": item.node,
                    "product-code": item.code,
                    "detail-page-url": item.detailPageUrl,
                    "product-img": item.picture,
                    "product-price": item.price,
                    unit: item.unit,
                    "product-package": item.package,
                    discount: _vm.discount,
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("button", {
          staticClass: "arrow arrow-prev",
          class: { hidden: _vm.hideNavigationButtons },
        }),
        _vm._v(" "),
        _c("button", {
          staticClass: "arrow arrow-next",
          class: { hidden: _vm.hideNavigationButtons },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }